import { routes } from '../../routes';
import { useAuth } from '../../hooks/auth';
import { useNavigate } from 'react-router-dom';
interface ProtectedRouteProps {
  children: JSX.Element;
}
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user) {
    navigate(`${routes.SIGN_OUT.path}${window.location.search}`);
  }

  return children;
}
